import React from 'react';
import {
  WarningRounded as ErrorRoundedIcon,
} from '@material-ui/icons';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core';

import styles from './styles';

const ChartError = ({
  height = 500,
  message,
  title,
}) => {
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  return (
    <div className={classes.errorContainer} style={{ height }} >
      <div className={classes.dialog}>
        <div className={classes.title}>
          <ErrorRoundedIcon className={classes.errorIcon} />
          <span>{title}</span>
        </div>
        <div className={classes.message}>
          <span>{message}</span>
        </div>
      </div>
    </div>
  );
};

ChartError.propTypes = {
  height: PropTypes.number,
  message: PropTypes.string,
  title: PropTypes.string,
};

export default ChartError;
